<template>
  <div class="page-subscribe-setting">
    <ym-cell v-for="(item, index) in list"
             :key="index"
             :title="item.title"
             :border="false"
    >
      <ym-switch v-model="item.state"
                 @change="handleSetSubscribeStatus(item.state, item.type)"
      ></ym-switch>
    </ym-cell>
  </div>
</template>

<script>
  import { Cell, Switch } from '@ymba/ym-ui';
  import { getSubscribeList, setSubscribe } from '@/services/subscribe';

  export default {
    name: 'SubscribeSetting',
    metaInfo: {
      title: '提醒设置',
    },
    data() {
      return {
        list: [],
      };
    },
    components: {
      'ym-cell': Cell,
      'ym-switch': Switch,
    },
    methods: {
      async fetchData() {
        const data = await getSubscribeList();
        data.list.map((item) => {
          if (item.state === 0) {
            item.state = false;
          } else {
            item.state = true;
          }
          return item;
        });
        this.list = data.list;
      },
      async handleSetSubscribeStatus(state, type) {
        const status = state ? 1 : 0;
        await setSubscribe(status, type);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped>

</style>
